import { useAuth0 } from '@auth0/auth0-react';
import { useLayoutEffect } from 'react';

import { clientSupervisionActions } from '../../../../../store';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { getNarrativeSuggestionContextKey } from '../../../../../utils/narrativeSuggestion';

import type { NarrativeSuggestionContext } from '../../../../../utils/types';
import type { INarrativeSuggestionResult } from '../../types';

function useClientNarrativeSuggestion(noteId: number | undefined, sourceKey: string) {
  const dispatch = useAppDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const narrativeSuggestionLoading = useAppSelector(
    (state) => state.clientSupervisions.narrativeSuggestionLoading,
  );
  const narrativeSuggestionKey = noteId
    ? getNarrativeSuggestionContextKey({ noteId, noteType: '97155', sourceKey })
    : null;

  useLayoutEffect(() => {
    if (!noteId) return;
    dispatch(
      clientSupervisionActions.setNarrativeSuggestionContext({
        noteId,
        noteType: '97155',
        sourceKey,
        contextToken: narrativeSuggestionKey ?? '',
      }),
    );
  }, [dispatch, narrativeSuggestionKey, noteId, sourceKey]);

  const getNarrativeSuggestion = (
    context: NarrativeSuggestionContext,
  ): Promise<INarrativeSuggestionResult> =>
    dispatch(
      clientSupervisionActions.getNarrativeSuggestion({
        supervisionId: context.noteId,
        noteId: context.noteId,
        noteType: context.noteType,
        sourceKey: context.sourceKey,
        contextToken: getNarrativeSuggestionContextKey(context),
        getAccessTokenSilently,
      }),
    );

  return { narrativeSuggestionLoading, getNarrativeSuggestion };
}

export default useClientNarrativeSuggestion;
